export default {
  1: {
    0: 'SOFT 1',
    1: 'SOFT 2',
    2: 'SOFT 3',
    3: 'SOFT 4',
    4: 'MEDIUM 1',
    5: 'MEDIUM 2',
    6: 'MEDIUM 3',
    7: 'MEDIUM 4',
    8: 'FIRM 1',
    9: 'FIRM 2',
    10: 'FIRM 3',
    11: 'FIRM 4',
    12: 'HARD 1',
    13: 'HARD 2',
    14: 'HARD 3',
    15: 'HARD 4',
  },
  2: {
    0: 'LFO',
    1: 'RANDM',
    2: 'ENV1',
    3: 'ENV2',
    4: 'PR+VL',
    5: 'VEL',
    6: 'VEL 1',
    7: 'VEL 2',
    8: 'KBD',
    9: 'PITCH',
    10: 'WHEEL',
    11: 'PEDAL',
    12: 'XCTRL',
    13: 'PRESS',
    14: 'WL+PR',
    15: 'OFF',
  },
  3: {
    0: 'CURRENT VALUE',
    1: 'FULL ON',
    2: 'ALL ZEROS',
    3: 'FULL VELRANGE',
    4: 'SLOW STRING',
    5: 'PIANO DECAY',
  },
  4: {
    0: 'F1=2/LP F2=2/HP',
    1: 'F1=3/LP F2=1/HP',
    2: 'F1=2/LP F2=2/LP',
    3: 'F1=3/LP F2=1/LP',
  },
  5: {
    0: 'WAVESAMPLE',
    1: '*-',
    2: '-*',
    3: '--*-',
    4: '*-*-',
    5: '--w--',
    6: '--*--',
    7: '--w',
    8: '*---',
    9: 'SOLO OUT 1',
    10: 'SOLO OUT 2',
    11: 'SOLO OUT 3',
    12: 'SOLO OUT 4',
    13: 'SOLO OUT 5',
    14: 'SOLO OUT 6',
    15: 'SOLO OUT 7',
    16: 'SOLO OUT 8',
    17: 'RANDOM PAN',
    18: 'KEYBOARD',
  },
  6: {
    0: 'TRIANGLE',
    1: 'SIN/TRIANGLE',
    2: 'SIN WAVE',
    3: 'POS/TRIANGLE',
  },
  7: {
    0: '2 MG',
    1: '1 MG',
    2: '512 K',
    3: '256 K',
    4: '128 K',
    5: '64 K',
    6: '32 K',
    7: '16 K',
    8: '8 K',
    9: '4 K',
    10: '2 K',
    11: '1 K',
    12: '512 B',
    13: '256 B',
    14: '128 B',
    15: '64 B',
    16: '32 B',
    17: '16 B',
    18: '8 B',
    19: '4 B',
    20: '2 B',
    21: '1 B',
  },
  8: {
    0: 'FORWARD-NO LOOP',
    1: 'BACKWARD-NO LOOP',
    2: 'LOOP FORWARD',
    3: 'LOOP BIDIRECTION',
    4: 'LOOP AND RELEASE',
  },
};
